import { gql } from '@apollo/client';

export const DELETE_APPROVAL_TYPE = gql`
  mutation deleteApprovalType($input: DeleteApprovalTypeInput) {
    deleteApprovalType(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_APPROVAL_TYPE_LIST = gql`
  mutation exportApprovalTypeList($filters: ExportApprovalTypeListInput) {
    exportApprovalTypeList(filters: $filters) {
      fileId
      fileName
      filePath
    }
  }
`;
